import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container, CssBaseline, Toolbar } from "@mui/material";
import Sidebar from "../../sidebar/Sidebar";
import AssetsManagerList from "./AssetsManagerList";
import AssetsManagerFilter from "./AssetsManagerFilter";
import AssetsManagerSuccessPrompt from "./AssetsManagerSuccessPrompt";
import AssetsManagerErrorPrompt from "./AssetsManagerErrorPrompt";
import AssetsManagerInfoPrompt from "./AssetsManagerInfoPrompt";
import { TypographyXLarge, TypographyNormal } from "../../customComponent";

const AssetManager = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("assetmanager");

  const { user, features } = useSelector((state) => state.auth);
  const permission = user?.permission;

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    if (features?.["ASSET"] === false) {
      navigate("/");
      return;
    }

    if (permission && !permission.asset?.read) {
      navigate("/");
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, features]);

  if (!features?.enabled) {
    return (
      <div style={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 1 }}></Box>
      </div>
    );
  }

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />

      <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
        <Toolbar />
        <CssBaseline />

        <Container maxWidth="xl">
          <Box sx={{ mb: 1 }}>
            <TypographyXLarge sx={{ fontWeight: 700 }}>
              {t("title")}
            </TypographyXLarge>
            <TypographyNormal sx={{ fontWeight: 400 }}>
              {t("titleExplain")}
            </TypographyNormal>
          </Box>

          <AssetsManagerInfoPrompt />
          <AssetsManagerSuccessPrompt />
          <AssetsManagerErrorPrompt />

          <Box sx={{ my: 2 }}>
            <AssetsManagerFilter />

            <AssetsManagerList assetPermission={permission?.asset} />
          </Box>
        </Container>
      </Box>
    </div>
  );
};

export default AssetManager;
